import enMessages from "../locales/en.json"
import esMessages from "../locales/es.json"

export const TOGGLE_LOCALE = 'intl/TOGGLE_LOCALE'
export const SET_LOCALE = 'intl/SET_LOCALE'

const messages = {
    en: enMessages,
    es: esMessages
}

let initialState = {
    locale: 'es',
    messages
}

export default (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_LOCALE:
            return {
                ...state,
                locale: state.locale === 'en' ? 'es' : 'en'
            }

        case SET_LOCALE:
            return {
                ...state,
                locale: action.locale
            }

        default:
            return state
    }
}

export const toggleLocale = () => {
    return dispatch => {
        dispatch({
            type: TOGGLE_LOCALE
        })
    }
}

export const setLocale = (locale) => {
    return dispatch => {
        dispatch({
            type: SET_LOCALE,
            locale
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/intl.js